<template>
    <div class="card-activity-inline">
        <div class="-cai-grid">
            <div class="-cai-graphics">
                <svg class="icon -cai-icon" v-lazysvg data-src="/images/icon/chat.svg#icon"></svg>
                <!-- OR -->
<!--                <svg class="icon -cai-icon" data-src="/images/icon/thumb_up.svg#icon"></svg>-->

            </div>
            <div class="-cai-paragraph">
                <span class="-cai-username">{{ author.name }}</span>
                <span>{{ activity.text }}</span>
                "<a :href="links.profile">{{ title }}</a>"
                <span class="-cai-date">{{ created.text }}</span>
            </div>
            <div class="-cai-close">
                <button class="btn transparent small nowrap">
                    <svg class="icon solo" v-lazysvg data-src="/images/icon/close.svg#icon"></svg>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'NotificationsItemActivity',
        props: {
            id: Number,
            title: String,
            images: Object,
            links: Object,
            actor: Object,
            network: Object,
            channel: Object,
            date: String,
            author: Object,
            activity: Object,
            created: Object,
        },
    }
</script>

<style>
    .card-activity-inline {
        float: left;
        width: 100%;
    }

    .-cai-grid {
        display: grid;
        grid-template: auto / 48px 1fr 25px;
        gap: 0 5px;
        align-items: center;
    }

    .-cai-graphics {
        justify-self: center;
    }

    .-cai-icon {
        width: 32px;
        height: 32px;
        opacity: .5;
    }

    .-cai-paragraph {
        font-size: 13px;
        line-height: 1.2em;
        margin: 2px 0;
    }

    .-cai-username,
    .-cai-paragraph a {
        color: #f2f580;
        font-weight: 400;
    }

    .-cai-paragraph a:hover {
        opacity: .75;
    }

    .-cai-date {
        display: inline-block;
        vertical-align: top;
        width: 100%;
        font-size: 11px;
        line-height: 1.2em;
        opacity: .75;
        margin: 2px 0;
    }
    .-cai-close {
        justify-self: center;
    }

    @media (min-width: 768px) {
        .card-activity-inline {
            padding-top: 10px;
            margin-bottom: -10px;
        }

        .-cai-grid {
            grid-template: auto / 48px 1fr 60px;
            gap: 0 10px;
        }

        .-cai-paragraph {
            font-size: 14px;
            line-height: 1.4em;
        }

        .-cai-date {
            font-size: 12px;
            line-height: 1.4em;
        }
    }
</style>
